'use client';

import {
  SessionProvider as NextSessionProvider,
  SessionProviderProps,
} from 'next-auth/react';

export function SessionProvider({ children }: SessionProviderProps) {
  return <NextSessionProvider>{children}</NextSessionProvider>;
}
